import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const AdminSettings = () => {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        api.get("/settings").then(({ data }) => setEmail(data.notify_email || ""));
    }, []);

    const save = async (e) => {
        e.preventDefault();
        try {
            setBusy(true);
            await api.put("/settings", { notify_email: email });
            toast.success("Settings saved");
        } catch (err) {
            toast.error("Save failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="admin-settings-page">
            <div className="overline text-red-600 mb-3">Settings</div>
            <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl mb-10">Site Settings</h1>

            <form onSubmit={save} className="bg-white border border-gray-200 p-8 max-w-2xl">
                <div className="overline text-red-600 mb-2">Inquiry Notifications</div>
                <p className="text-sm text-gray-600 mb-6">
                    All new quote inquiries from the public site will be emailed to this address (via Resend).
                </p>
                <label className="label-mono">Notification Email</label>
                <input type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="settings-notify-email" />

                <button type="submit" disabled={busy} className="btn-primary mt-8" data-testid="settings-save">
                    {busy ? "Saving…" : "Save Settings"}
                </button>
            </form>
        </div>
    );
};

export default AdminSettings;
